import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FieldConfig } from '../../../_models/field.interface';
@Component({
  selector: 'app-carousel',
  template: `
    <div
      [ngStyle]="field.styleDivPrincipal() ? field.styleDivPrincipal() : null"
    >
      <!-- <carousel
        [arrows]="field.showArrows"
        [cellWidth]="field.maxSize"
        [height]="field.height"
        style="z-index: 1"
      >
        <div
          [ngStyle]="itemCarousel.styleItem ? itemCarousel.styleItem() : null"
          class="carousel-cell"
          *ngFor="let itemCarousel of field.itensCarousel"
          (click)="itemCarousel.onClick ? itemCarousel.onClick() : return"
        >
          <img [src]="itemCarousel.imgBackground" />
          <a (click)="irParaPagina(itemCarousel.link)">
            <img
              [src]="itemCarousel.imgIcon"
              [ngStyle]="
                itemCarousel.styleImgIcon() ? itemCarousel.styleImgIcon() : null
              "
            />
            <label
              [ngStyle]="
                itemCarousel.styleLabel() ? itemCarousel.styleLabel() : null
              "
              >{{ itemCarousel.label }}</label
            >
          </a>
        </div>
      </carousel> -->
    </div>
  `,
  styles: [],
})
export class CarouselComponent {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor(private router: Router) {}
  irParaPagina(link: string): void {
    if (link) this.router.navigate([link]);
  }
}
